import React from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { ICapability, ICapabilityFormValues } from '../../types/capability'
import { IPublishingLocation } from '../../types/publishingLocations'
import { push } from '../../actions/router'
import { updateCapability } from '../../actions/capability'
import {
  transformCapabilityInputToState,
  transformCapabilityStateToInput,
} from '../../services/capability'
import { capabilityValidationSchema } from '../CapabilityForm/validation'
import { CapabilityForm } from '../../forms'
import { NavigationGuard } from '../../components'

interface IUpdateCapabilityForm {
  capability: ICapability
  publishingLocations: IPublishingLocation[]
  dispatch: Dispatch
}

export const UpdateCapabilityForm = ({
  capability,
  publishingLocations,
  dispatch,
}: IUpdateCapabilityForm) => (
  <Formik
    key={capability.modified}
    initialValues={transformCapabilityStateToInput(capability)}
    validationSchema={capabilityValidationSchema}
    onSubmit={(values: ICapabilityFormValues) =>
      dispatch(
        updateCapability(
          transformCapabilityInputToState(values, publishingLocations)
        )
      )
    }
    render={(formikProps) => (
      <>
        <CapabilityForm
          formikProps={formikProps}
          cancelAction={() => {
            formikProps.resetForm()
            dispatch(push('/settings/capabilities?tab=all-capabilities'))
          }}
          submitText="Save"
        />
        <NavigationGuard isBlocking={formikProps.dirty} />
      </>
    )}
  />
)
